import React from 'react';
import { Card, Col, Pagination, message, Row, Tag} from 'antd';

import { _getProducts } from '../actions';

import ItemCard from './item-card';

class ProfileBody extends React.Component {
    render() {
        const { products } = this.state;

        // if(!this.state.products) {
        //     return <div>Loading..</div>
        // }
        return(
            <Row 
                gutter={24}
                className="profile-body" 
                type="flex" >       
                    {
                        (!this.state.products)?
                        [
                            <Col span={6} >
                                <Card style={{height:'417px'}} loading={true}>a</Card>
                            </Col>,
                            <Col span={6} >
                                <Card style={{height:'417px'}} loading={true}>a</Card>
                            </Col>,
                            <Col span={6} >
                                <Card style={{height:'417px'}} loading={true}>a</Card>
                            </Col>,
                            <Col span={6} >
                                <Card style={{height:'417px'}} loading={true}>a</Card>
                            </Col>
                    ]:

                    <div style={{width: '100%'}}>

                        {(this.state.products.length<1)? 
                            <div>
                                No products uploaded
                            </div>
                        :
                            <Row gutter={24}>
                                
                                <Row style={{ marginBottom: 32 }} type="flex" justify="space-between">
                                    <Col>
                                        <Tag color="geekblue"> 
                                            {`${this.state.count} Items`}
                                        </Tag>
                                    </Col>

                                    <Col>
                                        <Pagination 
                                            current={ this.state.page } 
                                            total={ this.state.count } 
                                            pageSize={ 60 } 
                                            onChange={ page => this.getPage( page ) }
                                            />
                                    </Col>

                                    
                                </Row>

                                <Row style={{marginTop: '4px'}}>
                                    {products.map(
                                        (product, _id) => {
                                            // console.log(product, " / / / " , _id)
                                            return(
                                                <Col span={6} className="item-card-container">
                                                    <ItemCard 
                                                        product={product} />
                                                </Col>
                                            )
                                        }
                                    )}
                                </Row>
                            </Row>
                        }
                    </div>
                }
            </Row>
        )
    }

    constructor(props) {
        super(props);
        this.state = {
            products: false,
            page: 1
        }
    }

    componentWillMount() {

        this.getPage( 1 );
    }

    getPage( page ){

        let loader = message.loading('Loading products...');

        _getProducts(this.props.supplierId, page)
            .then( res => {
                
                loader();

                this.setState({
                    products: res.data.products,
                    count: res.data.count,
                    page
                })
            })

    }
}

export default ProfileBody;


// WEBPACK FOOTER //
// ./src/components/supplier-profile/profile-body/index.js